import React from 'react'

import { AsyncSelect, Form, Button } from '_zari/core'

import { NuevoSocioOtrosModal } from 'sharedComponents/modals'

import * as SocioService from 'services/socio.service'

const Select2SocioOtrosInput = ({ id, disabled, showNewButton, onChange, onCreate }) => {
  const [mostrarNuevoSocioModal, setMostrarNuevoSocioModal] = React.useState(false)
  const defaultDataRef = React.useRef({})

  const loadSociosSelect = React.useCallback((inputValue, resolve) => {
    defaultDataRef.current.numeroDocumento = inputValue

    SocioService.obtenerSociosOtrosxBusquedaAsSelect2({
      busqueda: inputValue,
      tipoSalida: 'codigo-ruc'
    })
      .then(({ data }) => resolve(data))
      .catch(() => resolve([]))
  }, [])

  const clickMostrarNuevoSocioModalHandler = React.useCallback(() => {
    setMostrarNuevoSocioModal(true)
  }, [])

  const innerOnCreate = React.useCallback(
    creationResult => {
      onCreate(creationResult, () => {
        setMostrarNuevoSocioModal(false)
      })
    },
    [onCreate]
  )

  return (
    <>
      {showNewButton ? (
        <Form.InputGroup>
          <AsyncSelect selectId={id} loadOptions={loadSociosSelect} onChange={onChange} />
          <Form.InputGroup.Append>
            <Button disabled={disabled} onClick={clickMostrarNuevoSocioModalHandler}>
              &#x2b;
            </Button>
          </Form.InputGroup.Append>
        </Form.InputGroup>
      ) : (
        <AsyncSelect selectId={id} loadOptions={loadSociosSelect} onChange={onChange} />
      )}
      {mostrarNuevoSocioModal && (
        <NuevoSocioOtrosModal
          handleClose={() => setMostrarNuevoSocioModal(false)}
          show={mostrarNuevoSocioModal}
          onCreate={innerOnCreate}
          defaultData={defaultDataRef.current}
        />
      )}
    </>
  )
}

export default React.memo(Select2SocioOtrosInput)
